export const addDocument = text =>(
    {
    type:"ADD_DOCUMENT",
    payload: text
})

export const removeDocument = document =>({
    type:"REMOVE_DOCUMENT",
    payload: document
})